module.exports = __webpack_public_path__ + "static/assets/535c95934f0770cadb9411839a2e037f.svg";